const SERVER_URL_DEV = 'https://dev.teamject.com';
const SERVER_URL_PROD = 'https://app.teamject.com'; // for prod

export const SERVER_URL = SERVER_URL_PROD; // change server url

// change in public/pdf/js/constants.js
